var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.getUserAccountRoles &&
    _vm.getUserAccountRoles.length &&
    _vm.getUserAccountRoles.length > 1
  )?_c('b-form-select',{attrs:{"value":_vm.getCurrentAccountRoleId},nativeOn:{"change":function($event){return _vm.updateRole($event.target.value)}}},[_c('template',{slot:"first"},[_c('option',{attrs:{"value":"default","disabled":""}},[_vm._v(" "+_vm._s(_vm.$t("label_snapshotSelector_roles"))+" ")])]),_vm._l((_vm.getUserAccountRoles),function(item,itemIndex){return _c('option',{key:itemIndex,domProps:{"value":item.id}},[_vm._v(" "+_vm._s(_vm.$t(item.name))+" ")])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }